/* Navraee — stale-tab freshness guard.

   WHY THIS EXISTS
   Storefront HTML is served `cache-control: private, no-store`, so no browser may
   cache it, and this theme registers no service worker (verified: 0 registrations,
   empty Cache API, no IndexedDB). A customer arriving fresh therefore cannot get
   stale HTML.

   The one real exception is iOS Safari's back/forward cache. Safari suspends tabs
   indefinitely and restores them from an in-memory snapshot WITHOUT revalidating,
   so a customer who left a tab open before a deployment can still be looking at the
   old page days later. That is the case this file fixes — and only that case.

   BEHAVIOUR
   Reloads only when BOTH are true:
     1. the page was restored from bfcache  (pageshow.persisted === true)
     2. that page has been alive longer than MAX_AGE_MS

   SAFETY
   - Cannot loop: a reload is a fresh navigation, so `persisted` is false and the
     page age resets to zero.
   - Never runs on a normal page load, so it has no effect on LCP, INP, CLS or any
     Lighthouse score — Lighthouse only performs cold loads.
   - Makes no network request and stores nothing, so Safari ITP storage eviction
     cannot affect it.
   - Cart and customer session are cookie/server-backed and survive a reload intact.
   - Theme JavaScript does not execute on Shopify's hosted checkout, so checkout is
     untouched.
   - Recent restores (under MAX_AGE_MS) keep bfcache's instant back-button speed.
*/
(function () {
  var MAX_AGE_MS = 30 * 60 * 1000; // only reload tabs older than 30 minutes

  window.addEventListener('pageshow', function (event) {
    if (!event || !event.persisted) return;              // not a bfcache restore

    var origin = (window.performance && performance.timeOrigin) || 0;
    if (!origin) return;                                 // unknown age — do nothing

    if (Date.now() - origin < MAX_AGE_MS) return;        // fresh enough, keep it snappy

    window.location.reload();
  });
})();
